import { PlatformCode } from 'type/common';
import { api } from './api';

export interface ISearchParams {
	keyword: string;
	page_size: string;
	platform_code: PlatformCode | string;
	exact_username?: string;
	ig_exclude?: string;
	yt_exclude?: string;
	nb_exclude?: string;
	tt_exclude?: string;
	division?: 'username' | 'etc';
}

export interface IExistence {
	platform_code: PlatformCode;
	keyword: string;
}

export const search_apis = {
	getSearch: async (page: number, params: ISearchParams) => {
		const data = await api.get(`discover/influencer/search`, {
			params: { ...params, page: page },
		});

		return data.data.result;
	},
	getSearchRecommend: async (keyword: string) => {
		const data = await api.get(`discover/influencer/search/recommendation`, {
			params: { keyword: keyword },
		});

		return data.data.result;
	},
	getInfluencerExistence: async (params: IExistence) => {
		const data = await api.get(`/discover/influencer/existing`, {
			params: params,
		});

		return data.data.result;
	},
};
